import { ThesisKeywordType } from 'pages/DrLicitaCreateDocument';
import Api from 'services/api';
import ApiFiles from 'services/api_files';

interface BlockInventoryType {
  id: number;
  block_objective: string;
  block_reference: string;
  block_related_words: string;
  block_text: string;
  block_text_words_list: string;
  document_type_id: number;
  law_type_id: number;
  proc_text: string;
  status: string;
  title: string;
}
interface BlockType {
  block_inventory: BlockInventoryType;
  from_keywords: boolean;
  sim_percent: number;
}

interface DocumentType {
  id: number;
  doc_text: string;
  title: string;
  created_at: string;
}

interface DocumentTemplateType {
  blocks: Array<BlockInventoryType>;
  document: DocumentType;
}

interface FetchThesesInAssistantsProps {
  knowledge_base: ThesisKeywordType[];
  text_snippet: string;
}

export const createBlockSelection = async (
  setShowProgress: (value: React.SetStateAction<boolean>) => void,
  setShowError: (value: React.SetStateAction<boolean>) => void,
  setShowSuccess: (value: React.SetStateAction<boolean>) => void,
  setBlocksSelection: (value: React.SetStateAction<Array<BlockType>>) => void,
  setActiveStep: (value: React.SetStateAction<number>) => void,
  lawTypeId: number,
  documentTypeId: number,
  textSnippet: string = '',
  keywords: string = '',
  pageNum: number = 1,
  file: File | null = null,
  theses: ThesisKeywordType[] = [],
) => {
  const formData = new FormData();
  if (file) {
    formData.append('selectedFile', file);
    formData.append('theses', JSON.stringify(theses));
  }

  formData.append('document_type_id', documentTypeId.toString());
  formData.append('law_type_id', lawTypeId.toString());
  formData.append('document_text_snippet', textSnippet);
  formData.append('key_words', keywords);
  formData.append('page_num', pageNum.toString());

  const response = await Api.post('/dr_licita/blocks_selections', formData);

  setShowProgress(false);

  if (response?.status !== 201) return setShowError(true);

  setBlocksSelection(response.data.blocks_selection);
  setActiveStep(2);

  return setShowSuccess(true);
};

export const assignUnassignBlock = async (blockId: number, action: string) => {
  const params = {
    block_id: blockId,
    block_action: action,
  };
  const response = await Api.post('/dr_licita/blocks_assigment', params);

  if (response?.status !== 200) return 'Error';

  return 'Success';
};

export const createDocumentTemplate = async (
  setShowProgress: (value: React.SetStateAction<boolean>) => void,
  setShowError: (value: React.SetStateAction<boolean>) => void,
  setShowSuccess: (value: React.SetStateAction<boolean>) => void,
  setActiveStep: (value: React.SetStateAction<number>) => void,
  setDocumentTemplate: (value: React.SetStateAction<DocumentTemplateType>) => void,
) => {
  const response = await Api.post('/dr_licita/documents');

  setShowProgress(false);

  if (response?.status !== 201) return setShowError(true);

  setDocumentTemplate(response.data);
  setActiveStep(3);

  return setShowSuccess(true);
};

export const exportDocument = async (documentId: number, title: string, formatDocument: string) => {
  const response = await ApiFiles.get(
    `/dr_licita/generate_user_document_file?document_id=${documentId}&format_document=${formatDocument}`,
  );

  if (response?.status === 200) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${title}_${Date.now()}.${formatDocument}`);
    document.body.appendChild(link);
    link.click();
  }
};

export const fetchThesesInAssistants = async (data: FetchThesesInAssistantsProps) => {
  const response = await Api.post('/dr_licita/theses_keywords/search_theses_with_assistant', {
    data,
  });

  if (response?.status === 200) {
    return response.data;
  }

  return [];
};

export const fetchThesesKeywords = async (document_type_id: number, law_type_id: number) => {
  if (document_type_id === 0 || law_type_id === 0) return [];

  const response = await Api.get(
    `/dr_licita/theses_keywords?document_type_id=${document_type_id}&law_type_id=${law_type_id}`,
  );

  if (response?.status === 200) {
    return response.data;
  }

  return [];
};
